const riot = require('riot');

riot.tag2('modal-calendar-mini', '<div class="w472 bg-white border py42 px14 rounded-8" ref="modal"> <div data-is="module-calendar-mini"></div> </div>', 'modal-calendar-mini,[data-is="modal-calendar-mini"]{ background-color: rgba(46, 46, 56, 0.7); }', 'class="f fh" spat-animation="push"', function(opts) {
});